import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { CustomCard } from "../../../../../Components";

import useStyles from "./styles";

function ActionsSkeletonLoader() {
  const styles = useStyles();

  return (
    <CustomCard
      classes={styles.cardStyle}
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
    >
      <Box className={styles.titleHeading}>
        <Skeleton variant="text" width="90px" height={40} />
      </Box>
      <Box
        className={styles.contentWrapper}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="background.paper"
      >
        <Skeleton variant="text" width="100%" height={55} />
        <Skeleton variant="text" width="100%" height={55} />
        <Skeleton variant="text" width="100%" height={55} />
        <Skeleton variant="text" width="100%" height={55} />
      </Box>
    </CustomCard>
  );
}

export default ActionsSkeletonLoader;
